import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllRegiones } from "../../action";
import TablaPreguntas from "./TablaPreguntas";

const ListPreguntasPortalInmobiliario = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.app.itemUsuario);
  const idBroker = userData && userData.tipoCuenta === 10 ? userData.userId : "";
  useEffect(() => {
    dispatch(fetchAllRegiones());
  }, []);
  return (
    <div className="contenido">
      <div className="header">
        <h2>Consultas Portal Inmobiliario</h2>
      </div>      
      <TablaPreguntas idCliente={""} idBroker={idBroker} incluirFiltro={true} inluirSelectClientes={true} />
    </div>
  );
};

export default ListPreguntasPortalInmobiliario;
